import React, { useEffect, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Collapse from '@mui/material/Collapse';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { baseLayers, envLayers } from '@/ol/layers';

function LayerItem({ layer }) {
  const layerVisible = layer.getVisible();
  const layerOpacity = layer.getOpacity();
  const [isVisible, setIsVisible] = useState(layerVisible);
  const [opacity, setOpacity] = useState(layerOpacity);

  useEffect(() => {
    layer.setVisible(isVisible);
  }, [layer, isVisible]);

  useEffect(() => {
    layer.setOpacity(opacity);
  }, [layer, opacity]);

  return (
    <ListItem sx={{ pl: 1 }}>
      <FormGroup sx={{ width: 260 }}>
        <FormControlLabel
          control={<Checkbox color="secondary" checked={isVisible} onChange={(e) => setIsVisible(e.target.checked)} />}
          label={layer.get('name')}
        />
      </FormGroup>
      <Box sx={{ width: 100, mr: 1 }}>
        <Slider
          color="secondary"
          aria-label="layer-slider"
          value={opacity}
          min={0}
          max={1}
          step={0.1}
          onChange={(e) => setOpacity(parseFloat(e.target.value))}
        />
      </Box>
    </ListItem>
  );
}

export default function LayerSwitcher() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleEnvLayers = () => {
    setIsOpen(!isOpen);
  };

  return (
    <List dense={true}>
      {baseLayers.map((layer, i) => (
        <LayerItem layer={layer} key={i} />
      ))}
      <ListItemButton sx={{ pl: 1 }}>
        <ListItemIcon sx={{ minWidth: 32 }} onClick={toggleEnvLayers}>
          {isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
        </ListItemIcon>

        <ListItemText primary={<Typography variant="subtitle1">Zonages environnementaux</Typography>} />
      </ListItemButton>
      <Collapse in={isOpen}>
        {envLayers.map((layer, i) => (
          <LayerItem layer={layer} key={i} />
        ))}
      </Collapse>
    </List>
  );
}

LayerItem.propTypes = {
  layer: PropTypes.object.isRequired,
};
